import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ItemTasa } from '../models/tasas.model';
import { PlataformaPagoModel } from '../models/plataforma-pago.model';
import { PagoModel } from '../models/pago.model';
import { PersonasSamFilter } from '../shared/filtros/personas-sam.filter';
import { CryptoService } from './crypto.service';

@Injectable({
  providedIn: 'root'
})
export class PagoTasasService {
  private _controllerName = 'pagos';

  constructor(private http: HttpClient, private cryptoService: CryptoService) {}

  public obtenerTasa(codigo): Observable<ItemTasa> {
    return this.http.get<ItemTasa>(`${this._controllerName}/obtenerTasa/?codigo=${codigo}`);
  }

  public generarPago(codigo: string, urlRedireccion?: string): Observable<PlataformaPagoModel> {
    const body: any = { codigo };
    if (urlRedireccion) {
      body.urlRedireccion = urlRedireccion;
    }
    return this.http.post<PlataformaPagoModel>(`${this._controllerName}/generarPago`, body, { withCredentials: true });
  }

  public consultarPago(idPago): Observable<PagoModel> {
    return this.http.get<PagoModel>(`${this._controllerName}/consultarPago/${idPago}`);
  }

  public existeUsuarioActivo(): Observable<any> {
    return this.http.post<any>(`${this._controllerName}/verificarUsuarioActivo`, {});
  }

  public generarUsuarioSam(datosPersona: PersonasSamFilter): Observable<any> {
    return this.http.post<PlataformaPagoModel>(`${this._controllerName}/generarUsuarioSam`, datosPersona);
  }
}
